// extracted by mini-css-extract-plugin
export default {"label":"zF133","dot":"I4Y4E","blink":"HEtRi","transparent":"izN5A","newDesign":"AMu9g"};